import { Stack, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

import PageContainer from 'components/common/PageContainer'
import { Header } from 'components/navigation/Header'
import { StatusCheckBreadcrumbs } from 'components/status-checks/common/StatusCheckBreadcrumbs'
import { CreateAuthenticationForm } from 'components/status-checks/create/CreateAuthenticationForm'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'

export const CreateAuthentication: React.FC = () => {
  const statusChecksUrls = getStatusChecksUrls()
  const location = useLocation()
  const { referrer = statusChecksUrls.base(), service } = location.state ?? {}

  const {
    isCreatingAuthenticationOnly,
    setIsCreatingAuthenticationOnly,
    isEdit,
    setIsEdit
  } = useContext(ObservabilityToolAuthenticationContext)

  useEffect(() => {
    if (!isCreatingAuthenticationOnly) {
      setIsCreatingAuthenticationOnly(true)
    }
  }, [isCreatingAuthenticationOnly, setIsCreatingAuthenticationOnly])

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false)
    }
  }, [isEdit, setIsEdit])

  return (
    <>
      <Helmet title="Create Health Check" />
      <Header>
        <StatusCheckBreadcrumbs
          endLabel="Create an Authentication"
          referrer={referrer}
          service={service}
        />
      </Header>
      <PageContainer>
        <Stack mb={3} spacing={3}>
          <Typography data-test-create-status-check-title variant="h5">
            Create a new Authentication
          </Typography>
          <Typography data-test-create-status-check-description>
            These Authentications can be reused to create Health Checks.
          </Typography>
        </Stack>
        <CreateAuthenticationForm />
      </PageContainer>
    </>
  )
}
